export type EventAutomationOptions = {
    type: "threshold" | "dutyCycle" | "none";
    parameters: number[];
};

/**
 * Represents a single instance of an irrigation event
 * This is used for scheduling and tracking irrigation events
 * Still needs proper migration to a schema
 */
export class EventInstance {
    public startDate: Date;
    public automationEvent = false;
    public automationOptions: EventAutomationOptions;
    public duration: number; // in seconds
    public zone: string;
    public rootIrrigationID: string | undefined;

    constructor(startDate: Date = undefined, MSduration: number = undefined) {
        this.startDate = startDate;
        this.duration = MSduration !== undefined ? MSduration / 1000 : undefined;
    }

    get durationMS(): number {
        return this.duration * 1000;
    }

    set durationMS(v: number) {
        this.duration = v / 1000;
    }

    get endDate(): Date {
        return new Date(this.startDate.valueOf() + this.durationMS);
    }
}
